(function($) {

  var animationSpeed = 300;

  var treeMenu = {

    bindMenu: function(element) {
      element.find('.l-2-group').slideUp(0);

      element.find('.l-1-item a').click(function() {

        var el = $(this).parents('.l-1-item');

        if(el.find('.l-2-group').size() === 0) return;

        el.parents('.tree-menu').find('.l-2-group').slideUp(animationSpeed);
        // debugger;
        if(el.hasClass('active')) {
            el.removeClass('active');
        } else {
            el.parents('.tree-menu').find('.l-1-item').removeClass('active');
            el.addClass('active');
            el.find('.l-2-group').slideDown(animationSpeed);
        }

      });
    },

    init: function() {
      var self = this;

      $('.tree-menu').each(function(i, e) {
        self.bindMenu($(e));
      });
    }
  };

  $(document).ready(function() {
    treeMenu.init();
  });

})(jQuery);
